import { render, staticRenderFns } from "./SubscriptionPricing.vue?vue&type=template&id=65012d0e"
import script from "./SubscriptionPricing.vue?vue&type=script&lang=js"
export * from "./SubscriptionPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports